import { createListLoader } from '@/store/utils/loader';

export default createListLoader({
  namespaced: true,
  config: {
    url: '/projects/api/v3/companies.json',
    module: 'company',
    params: ({ company }) => ({
      ...(company.filtered.restrictedCurrencyId && { currencyId: company.filtered.restrictedCurrencyId }),
      include: 'currencies',
    }),
    sort: false,
    pagination: { pageSize: 25 },
    mapResponse: (ctx, rs) => {
      const { companies, included = {} } = rs.data;
      const { currencies = {} } = included;
      return companies.map((company) => ({
        ...company,
        currency: currencies[company.currency?.id] ?? company.currency,
      }));
    },
  },
  state: {
    restrictedCurrencyId: null,
  },
  restrictCurrency: (state, currencyId) => {
    state.restrictedCurrencyId = currencyId;
  },
});
